import { apiBaseUrl } from 'services/config';

// The backend makes the login link itself, so a link that logs someone in on its own never has to
// travel through the browser.
export async function authenticateAdminGrant(
  adminGrantJwt: string,
): Promise<{ sessionToken: string; sessionJwt: string } | null> {
  try {
    const response = await fetch(`${apiBaseUrl}/admin-auth/authenticate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ adminGrantJwt }),
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data?.sessionToken && data?.sessionJwt ? data : null;
  } catch {
    return null;
  }
}
